import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CodeIcon from '@mui/icons-material/Code';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <h2>SoftLaabs</h2>
              <p className="footer-tagline">
                Transforming ideas into powerful digital solutions. We build custom software, 
                websites, desktop applications, and mobile apps that drive business success.
              </p>
              <div className="footer-social">
                <a href="https://wa.me/254792560128" target="_blank" rel="noopener noreferrer" aria-label="Whatsapp">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{width: '24px', height: '24px'}} />
                </a>
                <a href="mailto:softlaabs@softlaabs.org" target="_blank" rel="noopener noreferrer" aria-label="Gmail">
                  <EmailIcon />
                </a>
              </div>
            </div>

            <div className="footer-links">
              <h3>Services</h3>
              <ul>
                <li><Link to="/services">Website Development</Link></li>
                <li><Link to="/services">Mobile Applications</Link></li>
                <li><Link to="/services">Desktop Software</Link></li>
                <li><Link to="/services">Custom Solutions</Link></li>
                <li><Link to="/services">API Development</Link></li>
              </ul>
            </div>

            <div className="footer-links">
              <h3>Company</h3>
              <ul>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            <div className="footer-contact">
              <h3>Get In Touch</h3>
              <div className="contact-item">
                <EmailIcon />
                <div>
                  <span className="contact-label">Email</span>
                  <a href="mailto:softlaabs@softlaabs.org">softlaabs@softlaabs.org</a>
                </div>
              </div>
              <div className="contact-item">
                <PhoneIcon />
                <div>
                  <span className="contact-label">Phone</span>
                  <a href="tel:+254792560128">+254 792560128</a>
                </div>
              </div>
              <div className="contact-item">
                <LocationOnIcon />
                <div>
                  <span className="contact-label">Location</span>
                  <span>remote</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              <CodeIcon />
              <span>&copy; {new Date().getFullYear()} SoftLaabs. All rights reserved.</span>
            </div>
            <div className="footer-legal">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/cookies">Cookie Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
